import { render, staticRenderFns } from "./PopoverLegend.vue?vue&type=template&id=882e2e1a&scoped=true&"
import script from "./PopoverLegend.vue?vue&type=script&lang=js&"
export * from "./PopoverLegend.vue?vue&type=script&lang=js&"
import style0 from "./PopoverLegend.vue?vue&type=style&index=0&id=882e2e1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882e2e1a",
  null
  
)

export default component.exports